import { render } from "./orderPayed.vue?vue&type=template&id=5d75abc7&scoped=true"
import script from "./orderPayed.vue?vue&type=script&lang=js"
export * from "./orderPayed.vue?vue&type=script&lang=js"

import "./orderPayed.vue?vue&type=style&index=0&id=5d75abc7&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d75abc7"]])

export default __exports__